import { PlatformLayout } from "./platform-layout";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { WorkspacesContent } from "./platform-workspaces";
import { WaitlistContent } from "./platform-waitlist";
import { Building2, Clock } from "lucide-react";

export default function PlatformWorkspacesHub() {
  return (
    <PlatformLayout>
      <Tabs defaultValue="workspaces">
        <TabsList className="flex flex-wrap h-auto gap-1 mb-4">
          <TabsTrigger value="workspaces" data-testid="tab-ws-workspaces">
            <Building2 className="h-4 w-4 mr-1.5" />
            Workspaces
          </TabsTrigger>
          <TabsTrigger value="waitlist" data-testid="tab-ws-waitlist">
            <Clock className="h-4 w-4 mr-1.5" />
            Waitlist
          </TabsTrigger>
        </TabsList>

        <TabsContent value="workspaces">
          <WorkspacesContent />
        </TabsContent>
        <TabsContent value="waitlist">
          <WaitlistContent />
        </TabsContent>
      </Tabs>
    </PlatformLayout>
  );
}
